import Headroom from 'headroom.js';
import settings from '../../../../scripts/settings-headroom';

const elements = {
  header: document.body.querySelector('.js-header-alt'),
  container: document.body.querySelector('.js-header-alt-container'),
  cookie: document.body.querySelector('.js-cookie'),
  cookieButton: document.body.querySelector('.js-cookie-btn'),
};

const fixedClass = 'c-header__container--is-fixed';

function initialState() {
  if (window.pageYOffset > settings.offset) {
    elements.header.classList.add('c-header--is-pinned');
  }
}

function handleTabEvents() {
  document.body.addEventListener('mousedown', () => {
    document.body.classList.add('using-mouse');
    if (document.body.classList.contains('using-tabs')) {
      document.body.classList.remove('using-tabs');
      elements.container.classList.add(fixedClass);
    }
  });

  document.body.addEventListener('keydown', (e) => {
    document.body.classList.remove('using-mouse');
    if (e.which === 9) {
      document.body.classList.add('using-tabs');
      elements.container.classList.remove(fixedClass);
    }
  });
}

function init() {
  if (elements.header !== null) {
    const headroom = new Headroom(elements.header, settings);
    if ((elements.cookie !== null) && (!elements.cookie.classList.contains('is-visible'))) {
      headroom.init();
      initialState();
    } else {
      elements.header.classList.add('c-header--init');
      if (elements.cookie !== null) {
        elements.cookieButton.addEventListener('click', () => {
          headroom.init();
        });
      }
      else {
        headroom.init();
      }
    }

    handleTabEvents();
  }
}

export default init;


// WEBPACK FOOTER //
// ./src/components/components/turnbull/header/header.js